/**
 * Public one-click demo — no password, no review login.
 * Route: /demo — seeds Anna Exempel, then lands on home.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginDemo, saveDemoSession, DEMO_EMAIL } from "../lib/api";

export default function Demo() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("Öppnar publik demo…");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await loginDemo();
        if (cancelled) return;
        saveDemoSession(res.token, res.user);
        setStatus("Demo aktiv (Anna Exempel)…");
      } catch {
        if (cancelled) return;
        saveDemoSession("demo_stale_local", {
          email: DEMO_EMAIL,
          name: "Anna Exempel",
          firstName: "Anna",
          isDemo: true,
        });
        setStatus("Lokal demo aktiv…");
      }
      window.setTimeout(() => {
        if (!cancelled) navigate("/", { replace: true });
      }, 350);
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#F3F2F2",
        fontFamily: '"Lora", Georgia, serif',
        color: "#201f1d",
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 400,
          width: "100%",
          background: "#fff",
          borderRadius: 8,
          border: "1px solid #d7d3d3",
          padding: "28px 24px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 13, color: "#7d5411", letterSpacing: 0.4, marginBottom: 8 }}>
          PUBLIK DEMO · INGET KONTO
        </div>
        <h1 style={{ fontSize: 22, color: "#0B1F4A", margin: "0 0 12px" }}>
          GDPR Nordic
        </h1>
        <p style={{ margin: 0, color: "#605d5d", fontSize: 15, lineHeight: 1.5 }}>
          {status}
        </p>
        <p style={{ margin: "14px 0 0", fontSize: 13, color: "#9b9797" }}>
          Fiktiv profil — ingen inloggning krävs
        </p>
      </div>
    </div>
  );
}
